import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { Link } from "react-router";

dayjs.extend(customParseFormat);

type LitterCardProps = {
  image: string;
  name: string;
  description: string;
  father: any;
  mother: any;
  date: any;
  males: number;
  females: number;
  onNavigate?: () => void;
};

export const LitterCard = ({
  image,
  date,
  name,
  father,
  mother,
  males,
  females,
  onNavigate,
}: LitterCardProps) => {
  return (
    <Card
      onClick={onNavigate}
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        borderRadius: 2,
        backgroundColor: "rgba(255,255,255,0.8)",
        border: "1px solid #d4c4a8",
        cursor: onNavigate ? "pointer" : "default",
        "&:hover": onNavigate ? { boxShadow: 4 } : {},
      }}
    >
      <CardMedia
        component="img"
        sx={{
          width: { xs: "100%", sm: 180 },
          height: { xs: 200, sm: 180 },
          objectFit: image ? "cover" : "contain",
          backgroundColor: "#d4b483",
          flexShrink: 0,
          ...(!image && { padding: "12.5%" }),
        }}
        image={image || "/images/no_photo.png"}
        alt={name}
      />
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <CardContent sx={{ flex: "1 0 auto" }}>
          <Typography
            component="div"
            variant="h6"
            sx={{
              fontFamily: '"Cinzel", serif',
              color: "#4a3728",
              fontSize: "1rem",
            }}
          >
            {name}
          </Typography>
          <Typography
            variant="body2"
            component="div"
            sx={{ color: "#6b5b4a", mt: 1 }}
          >
            {/* {description} */}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: "#6b5b4a", fontFamily: '"EB Garamond", serif' }}
          >
            Available: {males} Males - {females} Females from{" "}
            {dayjs(date, "DD/MM/YYYY").format("MMMM D, YYYY")}
          </Typography>
          {father && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mt: 1,
                flexWrap: "wrap",
              }}
            >
              <Link
                to={`/dogs/${father.ID}`}
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={(e) => e.stopPropagation()}
              >
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    fontFamily: '"Cinzel", serif',
                    color: "#4a3728",
                    borderColor: "#d4b483",
                    backgroundColor: "rgba(212,180,131,0.15)",
                    textTransform: "uppercase",
                    letterSpacing: 1,
                    fontSize: "0.72rem",
                    px: 1.5,
                    width: "100px",
                    "&:hover": {
                      backgroundColor: "#d4b483",
                      borderColor: "#d4b483",
                      color: "#fff",
                    },
                  }}
                >
                  Father
                </Button>
              </Link>
              <Typography variant="body2" sx={{ color: "#4a3728" }}>
                {father.post_title}
              </Typography>
            </Box>
          )}
          {mother && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mt: 1,
                flexWrap: "wrap",
              }}
            >
              <Link
                to={`/dogs/${mother.ID}`}
                style={{ textDecoration: "none", color: "inherit" }}
                onClick={(e) => e.stopPropagation()}
              >
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    fontFamily: '"Cinzel", serif',
                    color: "#4a3728",
                    borderColor: "#d4b483",
                    backgroundColor: "rgba(212,180,131,0.15)",
                    textTransform: "uppercase",
                    letterSpacing: 1,
                    fontSize: "0.72rem",
                    px: 1.5,
                    width: "100px",
                    "&:hover": {
                      backgroundColor: "#d4b483",
                      borderColor: "#d4b483",
                      color: "#fff",
                    },
                  }}
                >
                  Mother
                </Button>
              </Link>
              <Typography variant="body2" sx={{ color: "#4a3728" }}>
                {mother.post_title}
              </Typography>
            </Box>
          )}
        </CardContent>
      </Box>
    </Card>
  );
};
